/**
 * Mapping status surat → tampilan (badge color + label).
 * Status values: "Pengajuan" | "Selesai" | "Batal"
 * (Legacy "Berhasil" sudah dimigrasi ke "Selesai" oleh backend.)
 */
export const STATUS_SURAT = {
  Pengajuan: {
    label: "Pengajuan",
    badge: "bg-amber-100 text-amber-800 hover:bg-amber-100",
    soft: "bg-amber-50 text-amber-700",
  },
  Selesai: {
    label: "Selesai",
    badge: "bg-emerald-100 text-emerald-800 hover:bg-emerald-100",
    soft: "bg-emerald-50 text-emerald-700",
  },
  Batal: {
    label: "Batal",
    badge: "bg-rose-100 text-rose-800 hover:bg-rose-100",
    soft: "bg-rose-50 text-rose-700",
  },
};

export function statusBadgeClass(status) {
  return STATUS_SURAT[status]?.badge || "bg-slate-100 text-slate-700 hover:bg-slate-100";
}
